<template>
  <b-modal
    id="metadata_search_modal"
    @show="onShow"
    @hide="onClose"
    @hidden="resetDataModal"
    centered
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
  >
    <p class="h3 text-capitalize filterTittle">{{ $t("messages.info.advanced_search") }}</p>
    <hr />

    <div class="filters-container">
      <slot name="main-filters"></slot>
      <div class="my-1"></div>
      <slot name="meta-filters"></slot>
    </div>

    <template #modal-footer="{ close }">
      <b-button variant="primary" size="sm" @click="onClearFiltersClick()" class="text-capitalize">
        {{ $t("messages.info.clear_filters") }}
      </b-button>
      <b-button variant="danger" size="sm" @click="close()">
        {{ $t("close") }}
      </b-button>
      <b-button variant="primary" size="sm" @click="onSearchClick(close)">
        {{ $t("search") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, getCurrentInstance } from "@vue/composition-api";

export default {
  components: {
    BModal,
    vSelect,
  },
  setup(_, { emit }) {
    const vm = getCurrentInstance().proxy;
    const onShow = () => {};
    const onClose = () => {};
    const resetDataModal = () => {};

    const onSearchClick = (close) => {
      emit("search");
      close();
    };

    const onClearFiltersClick = (close) => {
      emit("clear");
    };

    return {
      onShow,
      onClose,
      resetDataModal,
      onSearchClick,
      onClearFiltersClick,
    };
  },
};
</script>

<style lang="scss" scoped>
.dark-layout {
  .filterTittle {
  color: white;
  }
}
</style>
<style lang="scss">
#metadata_search_modal___BV_modal_content_ {
  overflow: auto !important;
}
</style>
